<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container">
    <promotional-plan-data />
  </div>
</template>

<script>
export default {
  name: 'promotionalPlan',
  components: {
    promotionalPlanData: () => import('@/views/ita/components/promotionalPlanData.vue'),
  },
}
</script>
